import * as React from 'react';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Body} from 'shells/typography/body';

export function DirectorySyncManagedUserBanner() {
    return (
        <FlashBanner hasBorder={true} type='info'>
            <div className='flex align-center full-width'>
                <Body color='blue'>This user was automatically created via Directory sync.</Body>
            </div>
        </FlashBanner>
    );
}
